<ldw-split-view [useSplitMode]="useSplitMode" [hasDetail]="hasDetail">
  <div class="split-view-content-list">
    @if (searchVisible) {
      <mat-toolbar>
        <mat-icon>search</mat-icon>
        <form [formGroup]="form" (submit)="submit()">
          <mat-form-field class="form-field" style="font-size: 14px">
            <input matInput type="text" formControlName="searchField" matTooltip="{{ showToolTip()? ('DIALOGS.CLOSE' | translate):'' }}" ldwAutofocus />
          </mat-form-field>
          <!-- hidden input required for submit with enter -->
          <button class="hiddenbutton" submit></button>
        </form>
        <button mat-icon-button (click)="submit()" matTooltip="{{ showToolTip()? ('SEARCH.START'| translate):'' }}">
          <mat-icon>play_arrow</mat-icon>
        </button>
        <button mat-icon-button (click)="scan()" type="button" matTooltip="{{ showToolTip()? ('SEARCH.QRCODE'| translate):'' }}">
          <!-- type="button" prevents submit -->
          <mat-icon>qr_code_scanner</mat-icon>
        </button>
        <button
          mat-icon-button
          class="closeButton"
          (click)="closeSearch()"
          matTooltip="{{ showToolTip()? ('DIALOGS.CLOSE' | translate):'' }}"
          type="button"
          >
          <mat-icon>close</mat-icon>
        </button>
      </mat-toolbar>
    }
    <ldw-structure-list-view [data]="documents" (itemSelected)="itemSelected($event)"> </ldw-structure-list-view>
    @if (!searchVisible) {
      <div class="floatingButton">
        <button mat-mini-fab color="primary" (click)="showSearch()" matTooltip="{{ showToolTip()? ('SEARCH.SEARCHINPLANTSTRUCTURE' | translate):'' }}"><mat-icon>manage_search</mat-icon></button>
      </div>
    }
  </div>
  @if (hasDetail) {
    <div class="split-view-content-detail">
      <ldw-detail-document-view [documentId]="detailDocumentId" (visibleChanged)="detailVisibleChanged($event)">
      </ldw-detail-document-view>
    </div>
  }
</ldw-split-view>
